import { apiFetch } from "#lib/api";
import { IS_DEVELOPMENT } from "#env/derived-vars";

interface Creator {
  service: string;
  id: string;
  name: string;
  indexed: number;
  updated: number;
  favorited: number;
}

export async function fetchProfiles(): Promise<Creator[]> {
  return await apiFetch<Creator[]>("/creators");;
}
